import useAccountData from "hooks/useAccountData";
import { Company } from "models/Company";
import { useEffect, useState } from "react";
import { useCart } from "react-use-cart";
import CheckoutForm from "./CheckoutForm";

const CheckoutFormList = () => {

    const cart = useCart();
    const { getCompanies, loadingCompanies } = useAccountData();

    const [companies, setCompanies] = useState<Company[]>([])


    useEffect(() => {
        async function fetchData() {
            if (!loadingCompanies) {
                const response = await getCompanies();
                if (response != null && response.length > 0) {
                    const documentIds = cart.items.map(item => item.documentId);
                    const uniqueDocumentIds = new Set(documentIds);

                    const filteredCompanies = response.filter(company =>
                        uniqueDocumentIds.has(company.id)
                    );
                    setCompanies(filteredCompanies);
                }
            }
        }
        fetchData();

    }, [loadingCompanies]);

    return <>
    
        {companies.length > 0 ?companies.map((company) => (
            <CheckoutForm key={company.id} companyId={company.id} />
        )) : null}

    </>
}

export default CheckoutFormList;